/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S16_P1_CInputs */

const tr_mesafeli_s16_p1_c = /** @type {(inputs: Mesafeli_S16_P1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` sayfalarına bakınız.`)
};

const en_mesafeli_s16_p1_c = /** @type {(inputs: Mesafeli_S16_P1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` pages.`)
};

const de_mesafeli_s16_p1_c = /** @type {(inputs: Mesafeli_S16_P1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const ru_mesafeli_s16_p1_c = /** @type {(inputs: Mesafeli_S16_P1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "pages." |
*
* @param {Mesafeli_S16_P1_CInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s16_p1_c = /** @type {((inputs?: Mesafeli_S16_P1_CInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S16_P1_CInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s16_p1_c(inputs)
	if (locale === "de") return de_mesafeli_s16_p1_c(inputs)
	if (locale === "ru") return ru_mesafeli_s16_p1_c(inputs)
	return tr_mesafeli_s16_p1_c(inputs)
});